export default __webpack_public_path__ + "static/media/Diabetes.735a246b.svg";